import React from "react";
import { useTranslation } from "react-i18next";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/react-splide/css";
import "./Testimonials.css";

const Testimonials = () => {
  const { t } = useTranslation();
  const row1 = t("home.testimonials.row1", { returnObjects: true });
  const row2 = t("home.testimonials.row2", { returnObjects: true });

  const splideOptions = (speed, direction = "ltr") => ({
    type: "loop",
    drag: "free",
    focus: "center",
    arrows: false,
    pagination: false,
    gap: 32,
    autoWidth: true,
    direction: direction,
    autoScroll: {
      pauseOnHover: true,
      pauseOnFocus: false,
      rewind: false,
      speed: speed,
    },
  });

  const renderCard = (item, index) => (
    <div key={index} className="testimonial-card">
      <p className="testimonial-text global-text">{item.content}</p>
      <div className="testimonial-user global-text">{item.user}</div>
    </div>
  );

  return (
    <section className="testimonials-wrapper">
      <div className="testimonials-bg-texture">
        <svg viewBox="0 0 1268 800" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M621.31 399.53L1044.78 823H733.315L512.625 602.31V822.839H292.387V-23.9395H512.625V196.751L733.376 -24H1044.84L621.31 399.53ZM220.239 822.839H0V-23.9395H220.239V822.839ZM1267.64 822.839H1047.4V-23.9395H1267.64V822.839Z" fill="white" fill-opacity="0.12" />
        </svg>
      </div>
      <div className="testimonials-header">
        <h2 className="testimonials-title global-title">{t("home.testimonials.title")}</h2>
      </div>

      <div className="testimonials-rows">
        {/* Row 1: Moving Left (positive speed) */}
        <div className="testimonial-row-container">
          <Splide extensions={{ AutoScroll }} options={splideOptions(1)}>
            {Array.isArray(row1) && row1.map((item, index) => (
              <SplideSlide key={index}>
                {renderCard(item, index)}
              </SplideSlide>
            ))}
          </Splide>
        </div>

        {/* Row 2: Moving Right (negative speed) */}
        <div className="testimonial-row-container">
          <Splide extensions={{ AutoScroll }} options={splideOptions(-1)}>
            {Array.isArray(row2) && row2.map((item, index) => (
              <SplideSlide key={index} className="staggered-slide">
                {renderCard(item, index)}
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
